/* eslint-disable no-nested-ternary */
import {
  faHome,
  faUser,
  faUtensils,
  faCreditCardAlt,
} from '@fortawesome/free-solid-svg-icons';

import WithSuspense from '../WithSuspense';
import { routeNames } from '../../../util/Constants';
import { isConsumerApp, isRestaurantApp } from '../../../util/Helpers';
import lazyWithRetry from '../../../util/lazyWithRetry';
import withRestaurantErrorBoundary from './RestaurantWithBoundary';

const Home = lazyWithRetry(() => import('../../page/Home'));
const RestaurantHome = lazyWithRetry(() =>
  import('../../page/RestaurantLanding/RestaurantLanding')
);
const Terms = lazyWithRetry(() => import('../../page/Terms'));
const Checkout = lazyWithRetry(() => import('../../page/Checkout'));
const Restaurant = lazyWithRetry(() => import('../../page/Restaurant'));
const TrackOrder = lazyWithRetry(() => import('../../page/TrackOrder'));
const Restaurants = lazyWithRetry(() => import('../../page/Restaurants'));
const NotFoundPage = lazyWithRetry(() => import('../../page/NotFoundPage'));
const OrderSuccess = lazyWithRetry(() => import('../../page/OrderSuccess'));
const ResetPassword = lazyWithRetry(() => import('../../page/ResetPassword'));
const OAuthCallback = lazyWithRetry(() =>
  import('../../page/OAuthCallback/OAuthCallback')
);
const AccountDetails = lazyWithRetry(() => import('../../page/AccountDetails'));
const GiftCards = lazyWithRetry(() => import('../../page/GiftCards'));
const PurchaseGiftCard = lazyWithRetry(() =>
  import('../../page/PurchaseGiftCard')
);
const RedeemGiftCard = lazyWithRetry(() => import('../../page/RedeemGiftCard'));
const GiftOrderConfirmation = lazyWithRetry(() =>
  import('../../page/GiftCardOrderConfirmation')
);
const TemplatePreview = lazyWithRetry(() =>
  import('../../page/TemplatePreview/TemplatePreview')
);

const isRestaurantWeb = isRestaurantApp();
const isConsumerWeb = isConsumerApp();

const routes = [
  {
    icon: faHome,
    title: 'Home',
    path: routeNames.home,
    component: isRestaurantWeb
      ? WithSuspense(RestaurantHome)
      : WithSuspense(Home),
  },
  {
    icon: faUtensils,
    title: 'Restaurants',
    path: routeNames.restaurants,
    component: isConsumerWeb
      ? WithSuspense(Restaurants)
      : WithSuspense(RestaurantHome),
  },
  {
    path: routeNames.restaurant,
    component: withRestaurantErrorBoundary(WithSuspense(Restaurant)),
  },
  {
    path: routeNames.contact,
    redirect: routeNames.home,
  },
  {
    path: routeNames.aboutus,
    redirect: routeNames.home,
  },
  {
    path: routeNames.restaurantMenu,
    component: isRestaurantWeb
      ? withRestaurantErrorBoundary(WithSuspense(Restaurant))
      : WithSuspense(NotFoundPage),
  },
  {
    path: routeNames.restaurantOrder,
    component: isRestaurantWeb
      ? withRestaurantErrorBoundary(WithSuspense(Restaurant))
      : WithSuspense(NotFoundPage),
  },
  {
    path: routeNames.checkout,
    component: WithSuspense(Checkout),
  },
  {
    icon: faUser,
    role: 'registered',
    path: routeNames.accountDetails,
    component: WithSuspense(AccountDetails),
  },
  {
    role: 'protected',
    path: routeNames.trackOrder,
    component: WithSuspense(TrackOrder),
  },
  {
    role: 'protected',
    path: routeNames.orderSuccess,
    component: WithSuspense(OrderSuccess),
  },
  {
    role: 'none',
    path: routeNames.resetPassword,
    component: WithSuspense(ResetPassword),
  },
  {
    role: 'none',
    path: routeNames.oauthCallback,
    component: WithSuspense(OAuthCallback),
  },
  {
    role: 'none',
    path: routeNames.termsAndConditions,
    component: WithSuspense(Terms),
  },
  {
    path: routeNames.notfound,
    component: WithSuspense(NotFoundPage),
  },
  {
    icon: faCreditCardAlt,
    title: 'Gift Cards',
    role: 'registered',
    path: routeNames.giftCards,
    component: WithSuspense(GiftCards),
  },
  {
    role: 'registered',
    path: routeNames.purchaseGift,
    component: WithSuspense(PurchaseGiftCard),
  },
  {
    role: 'registered',
    path: routeNames.redeemGift,
    component: WithSuspense(RedeemGiftCard),
  },
  {
    role: 'registered',
    path: routeNames.giftOrderConfirmation,
    component: WithSuspense(GiftOrderConfirmation),
  },
  {
    // Development / staging only — guarded inside the component itself
    path: routeNames.templatePreview,
    component: WithSuspense(TemplatePreview),
  },
];

export default routes;
